<!--
  AI:
  Status: "in progress"
  Type: Component
  SubType: CrudIntegration
  Reason: [T3 · P1] cw.CwRequestType object component — left navigation with one section per
    one-to-many child (Gesellschaften, Dokumentrollen, Tickettypen) plus the Stammdaten head with
    read/edit toggle. Guarded by @if (initialized && dto).
-->
@if (initialized && dto) {

    <!-- ==================== Übersicht: Stammdaten ==================== -->
    @if (activeNavigationItems?.action == 'overview') {
        <div class="cw-request-type-object p-3">
            <div class="flex align-items-center justify-content-between mb-2">
                <span class="text-lg font-medium">Antragstyp-Stammdaten</span>
                <p-button
                        [label]="editRequestType ? 'Ansicht' : 'Bearbeiten'"
                        [icon]="editRequestType ? 'fa-regular fa-eye' : 'fa-regular fa-pen'"
                        severity="secondary"
                        [text]="true"
                        (onClick)="toggleEditRequestType()">
                </p-button>
            </div>
            @if (!editRequestType && requestTypeDataWidget) {
                <mvs-widget [widgetData]="requestTypeDataWidget"></mvs-widget>
            }
            @if (editRequestType && requestTypeEditWidget) {
                <mvs-widget [widgetData]="requestTypeEditWidget"></mvs-widget>
            }
        </div>
    }

    <!-- ==================== Gesellschaften ==================== -->
    @if (activeNavigationItems?.action == 'partners') {
        <div class="cw-request-type-object p-3">
            @if (partnerWidget) {
                <mvs-widget [widgetData]="partnerWidget"></mvs-widget>
            }
        </div>
    }

    <!-- ==================== Dokumentrollen ==================== -->
    @if (activeNavigationItems?.action == 'documentRoles') {
        <div class="cw-request-type-object p-3">
            @if (documentRoleWidget) {
                <mvs-widget [widgetData]="documentRoleWidget"></mvs-widget>
            }
        </div>
    }

    <!-- ==================== Tickettypen ==================== -->
    @if (activeNavigationItems?.action == 'ticketTypes') {
        <div class="cw-request-type-object p-3">
            @if (ticketTypeWidget) {
                <mvs-widget [widgetData]="ticketTypeWidget"></mvs-widget>
            }
        </div>
    }

}
